const BASE_URL = "https://fast.codegraphi.in";

// ===== COMMON FUNCTION (Best Practice) =====
const handleResponse = async (res) => {
  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.detail || "Something went wrong");
  }

  return data;
};

// ===== AUTH =====
export const registerUser = async (data) => {
  const res = await fetch(`${BASE_URL}/auth/register`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: data.email,
      password: data.password,
    }),
  });

  return handleResponse(res);
};

export const loginUser = async (data) => {
  const res = await fetch(`${BASE_URL}/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: data.email,
      password: data.password,
    }),
  });

  return handleResponse(res);
};

// ===== BLOG =====
export const getBlogs = async () => {
  const res = await fetch(`${BASE_URL}/blog/`);
  return handleResponse(res);
};

export const createBlog = async (data, token) => {
  const res = await fetch(`${BASE_URL}/blog/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      title: data.title,
      content: data.content,
    }),
  });

  return handleResponse(res);
};

export const deleteBlog = async (id, token) => {
  const res = await fetch(`${BASE_URL}/blog/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(res);
};